@if (hasCompanyWideNotes && !isCustomer) {
  <div>
    @for (comment of companyWideNotes; track comment) {
      <div>{{comment.comment}}</div>
    }
  </div>
}
@if (!hasCompanyWideNotes) {
  <div style="font-style: italic;">
    No company wide notes.
  </div>
}